import ApiService from '../../../services/apiService';
import { mapState } from 'vuex';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';

export default {
  data: function () {
    return {
      loading: false,

      twinDataStates: null,
      // "foreign" dependencies of a twin that should be deleted
      twinDependencies: {},

      twinDuplicatePrompt: false,
      twinSyncPrompt: false,
      twinDeletePrompt: false,
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    hasTwinManageAllPermission() {
      return (this.permissions || {})['DigitalTwin.manage'];
    },
    canDeleteTwin() {
      return this.twinDependencies && (get(this.twinDependencies, 'aggregatedStates') || []).length === 0;
    },
  },
  methods: {
    forceRefreshStates() {
      this.twinDataStates = cloneDeep(this.twinDataStates);
    },
    twinCanBeEdited(twin) {
      return (this.permissions || {})['DigitalTwin.write'] && get(twin, 'properties.disabled') !== true;
    },
    twinCanBeDeleted() {
      return (this.permissions || {})['DigitalTwin.manage'];
    },
    loadStates(twin) {
      if (this.loading !== twin.id && twin.id) {
        this.loading = twin.id;
        return ApiService.digitalTwinFetchStates(this, twin.id)
          .then((twinDataStates) => {
            this.twinDataStates = twinDataStates.map((state) => {
              return Object.assign({}, state, {
                title: state.properties.title,
                unit: state.properties.unit,
              });
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    fetchTwinDependencies(twin) {
      this.loading = true;
      this.twinDependencies = null;
      return ApiService.digitalTwinGetDependencies(twin.id)
        .then((twinDependencies) => {
          twinDependencies.aggregatedStates.forEach((state) => {
            state.children = [
              {
                ...state.dtwin,
                icon: state.dtwin.twinType === 'virtualDevice' ? 'sensor-on' : 'dice-d8',
                isTwin: true,
              },
            ];
            state.title = `${state.title} (${state.key})`;
            state.icon = state.icon || 'layer-group';
          });
          this.twinDependencies = twinDependencies;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    duplicateCloseEvent() {
      this.twinDuplicatePrompt = false;
    },
    syncCloseEvent() {
      this.twinSyncPrompt = false;
    },
  },
};
